import React, { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';

const cardData = [
  { id: 'projects', label: 'Projects', value: 24 },
  { id: 'active-tasks', label: 'Active Tasks', value: 142 },
  { id: 'pending', label: 'Pending', value: 18 },
];

const initialMembers = [
  { id: 1, name: 'Aditi Sharma', role: 'Frontend Engineer' },
  { id: 2, name: 'Rahul Verma', role: 'Backend Engineer' },
  { id: 3, name: 'Meera Nair', role: 'Product Designer' },
];

const containerStyle = {
  maxWidth: 900,
  margin: '40px auto',
  padding: '0 24px',
  fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
};

const cardsRowStyle = {
  display: 'flex',
  gap: 20,
  marginBottom: 40,
  flexWrap: 'wrap',
};

const cardStyle = {
  flex: '1 1 200px',
  background: '#ffffff',
  borderRadius: 12,
  padding: '24px 20px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  textAlign: 'center',
  cursor: 'default',
};

const memberRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: '#ffffff',
  borderRadius: 10,
  padding: '14px 18px',
  marginBottom: 12,
  boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
};

const deleteButtonStyle = {
  background: '#fdecea',
  color: '#c0392b',
  border: 'none',
  borderRadius: 6,
  padding: '6px 14px',
  cursor: 'pointer',
  fontWeight: 600,
};

const addButtonStyle = {
  background: '#2563eb',
  color: '#fff',
  border: 'none',
  borderRadius: 8,
  padding: '10px 20px',
  cursor: 'pointer',
  fontWeight: 600,
  marginTop: 16,
};

let nextId = 4;

const sampleNames = [
  { name: 'Karan Patel', role: 'QA Engineer' },
  { name: 'Sneha Iyer', role: 'DevOps Engineer' },
  { name: 'Vikram Singh', role: 'Project Manager' },
];

export default function MotionDemo() {
  const [members, setMembers] = useState(initialMembers);

  const handleDelete = (id) => {
    setMembers((prev) => prev.filter((m) => m.id !== id));
  };

  const handleAdd = () => {
    const sample = sampleNames[nextId % sampleNames.length];
    setMembers((prev) => [...prev, { id: nextId++, ...sample }]);
  };

  return (
    <div style={containerStyle}>
      <h1>Motion Proof-of-Concept</h1>

      <div style={cardsRowStyle}>
        {cardData.map((card, index) => (
          <motion.div
            key={card.id}
            style={cardStyle}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            whileHover={{ scale: 1.05, boxShadow: '0 8px 20px rgba(0,0,0,0.15)' }}
          >
            <div style={{ fontSize: 32, fontWeight: 700 }}>{card.value}</div>
            <div style={{ color: '#666', marginTop: 6 }}>{card.label}</div>
          </motion.div>
        ))}
      </div>

      <h2>Team Members</h2>
      <AnimatePresence>
        {members.map((member) => (
          <motion.div
            key={member.id}
            layout
            style={memberRowStyle}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 40 }}
            transition={{ duration: 0.3 }}
          >
            <div>
              <div style={{ fontWeight: 600 }}>{member.name}</div>
              <div style={{ color: '#888', fontSize: 14 }}>{member.role}</div>
            </div>
            <button style={deleteButtonStyle} onClick={() => handleDelete(member.id)}>
              Delete
            </button>
          </motion.div>
        ))}
      </AnimatePresence>

      <motion.button
        style={addButtonStyle}
        onClick={handleAdd}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        + Add Member
      </motion.button>
    </div>
  );
}
